import { IEmailAttachment } from "../interfaces/services/IEmailAttachment";
import { EmailComposerBuilderService } from "./EmailComposerBuilderService";

export class EmailBuilderWrapper {
  static createNewEmail = async (attachments: IEmailAttachment[]) => {
    const builder = new EmailComposerBuilderService();
    builder
      .setRecipients([], [])
      .setSubjectAndBody("", "")
      .setAttachments(attachments)
      .execute();
  };

  static createNewEmailWithLink =  async (links: IEmailAttachment[]) => {
    const builder = new EmailComposerBuilderService();
    
    builder
      .setRecipients([], [])
      .setSubjectAndBody("", links.map(link =>`<a href="${link.url}">${link.name}</a><br/>`).join(''))
      .execute();
  };
}


